// @flow

import type {TreeItem, TreeStructure} from '../typedef';

export function iterateTree(
    tree: TreeStructure,
    callBack: ({ item: TreeItem, i: number, array: TreeStructure, parents: Array<TreeItem> }) => any,
    arrayMethodName: 'forEach' | 'find' = 'forEach'
) {
    const iterateWithParent = (parents: Array<TreeItem>) =>
        function iterate(item: TreeItem, i: number, array: TreeStructure) {
            if (item.children) {
                callMethod(item.children, iterateWithParent([...parents, item]));
            }
            return callBack({item, i, array, parents});
        };

    callMethod(tree, iterateWithParent([]));

    function callMethod<T>(array: Array<T>, callback: (T, number, Array<T>) => any) {
        switch (arrayMethodName) {
            case 'forEach':
                return array.forEach(callback);

            case 'find':
                return array.find(callback);

            default:
                return undefined;

        }
    }
}
